module.exports = __webpack_public_path__ + "img/like.9fb4106f.png";